import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

//styles
import { Colors } from "../../styles";

const Message = ({ text }) => {
	return (
		<Container>
			<Text>{text}</Text>
		</Container>
	);
};

Message.propTypes = {
	text: PropTypes.string,
	color: PropTypes.string,
};

export default Message;

const Container = styled.div`
	margin-top: 4rem;
	min-height: 50vh;
`;

const Text = styled.h3`
	text-align: center;
	color: ${Colors.base.black};
`;
